import React, { useEffect, useState } from "react";
import { backend, API_URL } from "../../../config";
import { Link } from "react-router-dom";
import {
  Button,
  Container,
  CssBaseline,
  Grid,
  Typography,
  IconButton,
  Modal,
  CircularProgress,
  Stack,
  Tooltip,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import "./Details.css";

import { useDispatch, useSelector } from "react-redux";
import {
  initialize_cart_action,
  add_to_cart_action,
} from "./../../../redux/actions/cart";

import DetailsOrder from "../../../components/Details/Order";

import PrintIcon from "@mui/icons-material/Print";
import DeleteIcon from "@mui/icons-material/Delete";

const useStyles = makeStyles((theme) => ({
  modal: {
    position: "absolute",
    width: 400,
    backgroundColor: "#fff",
    border: "1px solid rgba(0,0,0,.2)",
    borderRadius: ".3rem",
    boxShadow: theme.shadows[5],
    padding: "1rem",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
}));

const columns = {
  cart: [
    { id: "upc", label: "UPC" },
    {
      id: "url",
      label: "Image",
    },
    {
      id: "name",
      label: "Name",
    },
    {
      id: "display_unit_price",
      label: "Unit",
    },
    {
      id: "display_case_price",
      label: "Case",
    },
  ],
  order: [
    {
      id: "product",
      label: "UPC",
      visibility_allow_rid: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
    },
    { id: "bin", label: "Bin location" },
    { id: "item_code", label: "Item code", innerId: "item_code" },
    { id: "name", label: "Name" },
    { id: "unit_quantity", label: "Unit" },
    { id: "case_quantity", label: "Case" },
    { id: "price_per_type", label: "Pricing" },
    {
      id: "final_price",
      label: "Final price",
      visibility_allow_rid: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
    },
    {
      id: "combined_stock_level",
      label: "Combined stock",
      visibility_allow_rid: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
    },
  ],
};

const Details = (props) => {
  const orderId = props.match.params.id;
  const dispatch = useDispatch();
  const classes = useStyles();

  const [companyLocations, setCompanyLocations] = useState([]);
  const [customer, setCustomer] = useState({});
  const [order, setOrder] = useState({});
  const [orderItems, setOrderItems] = useState([]);
  const [orderItemsMapped, setOrderItemsMapped] = useState(false);
  const [products, setProducts] = useState([]);
  const [orderList, setOrderList] = useState(null);
  const [orderListPricing, setOrderListPricing] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [addToCartModal, setAddToCartModal] = useState(false);
  const [isAddingToCart, setIsAddingToCart] = useState(false);
  const [generateInvoiceModal, setGenerateInvoiceModal] = useState(false);
  const [loadingFlag, setLoadingFlag] = useState(false);
  const [finishedFlag, setFinishedFlag] = useState(false);
  const [errorInfo, setErrorInfo] = useState({ error: false, message: "" });

  const cartStore = useSelector((state) => state.cart);
  const currentUserStore = useSelector((state) => state.current_user);
  const customerStore = useSelector((state) => state.customer);

  const handleClickViewInvoice = () => {
    props.history.push(`/order/${order.id}/invoice`);
  };

  const toggleDeleteModal = () => {
    setIsDeleting(false);
    setDeleteModal(!deleteModal);
  };

  /* const deleteModalContent = (
    <div className={classes.modal}>
      Are you sure you want to delete order #{order.id}?
      <br />
      <br />
      <div align="right">
        <Button onClick={() => toggleDeleteModal()} className={classes.button}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => sendDeleteRequest()}
          className={classes.button}
        >
          Confirm
        </Button>
      </div>
    </div>
  ); */

  const deleteModalContent = (
    <div className={classes.modal}>
      {!isDeleting ? (
        <>
          Are you sure you want to delete
          <b> order #{order.id}</b>?
          <br />
          <br />
          <div align="right">
            <Button
              onClick={() => toggleDeleteModal()}
              className={classes.button}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => sendDeleteRequest()}
              className={classes.button}
            >
              Confirm
            </Button>
          </div>
        </>
      ) : (
        <>
          <div align="center">
            <CircularProgress />
            <div>Deleting order</div>
          </div>
          {errorInfo.error ? (
            <>
              <br />
              <br />
              There was an error while deleting the order
              <br />
              <br />
              <span
                style={{
                  color: "red",
                  wordBreak: "break-word",
                  maxHeight: 160,
                  overflow: "hidden",
                  display: "inline-block",
                }}
              >
                <b>Error:</b>
                <br />
                {typeof errorInfo.message === "object" ? (
                  <>
                    <ul>
                      {Object.keys(errorInfo.message).map((key) => (
                        <li key={key}>
                          <b>{key}:</b>
                          {` ${errorInfo.message[key]}`}
                        </li>
                      ))}
                    </ul>
                  </>
                ) : (
                  errorInfo.message
                )}
              </span>
              <div align="right">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => toggleDeleteModal()}
                  className={classes.button}
                >
                  Continue
                </Button>
              </div>
            </>
          ) : (
            <></>
          )}
        </>
      )}
    </div>
  );

  const sendDeleteRequest = async () => {
    setIsDeleting(true);
    await backend
      .delete(`${API_URL}orders/${order.id}`)
      .then(() => {
        setIsDeleting(false);
        toggleDeleteModal();
        props.history.push("/orders");
      })
      .catch((error) => {
        console.log(error);
        const errorData = error.response.data;

        setErrorInfo({
          error: true,
          message:
            typeof errorData === "object"
              ? errorData.hasOwnProperty("message")
                ? errorData.message
                : errorData.hasOwnProperty("message")
                  ? errorData.detail
                  : errorData
              : error.message,
        });
      });
  };

  const toggleAddToCartModal = () => setAddToCartModal(!addToCartModal);

  const addToCartModalContent = (
    <div className={classes.modal}>
      {!isAddingToCart ? (
        <>
          Are you sure you want to add order #{order.id} items to the cart?
          <br />
          <br />
          <div align="right">
            <Button
              onClick={() => toggleAddToCartModal()}
              className={classes.button}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => addToCart()}
              className={classes.button}
            >
              Confirm
            </Button>
          </div>
        </>
      ) : (
        <>
          <div align="center">
            <CircularProgress />
            <br />
            <br />
            Adding items to cart
            <br />
            <br />
            Please do not leave this page until this pop up is closed
            automatically
          </div>
        </>
      )}
    </div>
  );

  const addToCart = async () => {
    setIsAddingToCart(true);

    const orderItemsWPricing = orderItems.map((oiItem) => {
      oiItem["unit_in_cart"] = oiItem["unit_quantity"];
      oiItem["case_in_cart"] = oiItem["case_quantity"];

      let itemPricing = orderListPricing.find(
        (item) => oiItem.upc === item.upc,
      );

      if (!itemPricing) {
        itemPricing = products.find((item) => oiItem.upc === item.upc);
      }

      if (!itemPricing) return oiItem;

      return { ...oiItem, ...itemPricing };
    });

    if (!Object.keys(cartStore).includes("" + customer.id)) {
      dispatch(initialize_cart_action([], customer));
    }

    dispatch(add_to_cart_action(orderItemsWPricing, customer));

    toggleAddToCartModal(false);
    setIsAddingToCart(false);
  };

  const toggleGenerateInvoiceModal = () =>
    setGenerateInvoiceModal(!generateInvoiceModal);

  const dismissGenerateInvoiceModal = (redirect = false) => {
    setLoadingFlag(false);
    setFinishedFlag(false);
    toggleGenerateInvoiceModal();

    if (redirect) {
      props.history.push(`/order/${orderId}/invoice`);
    }
  };

  const generateInvoiceModalContent = (
    <div className={classes.modal}>
      {!loadingFlag && !finishedFlag ? (
        <>
          Generating an invoice will lock the order from further edits.
          <br />
          <br />
          Continue? <br />
          <Stack spacing={2} direction="row" justifyContent="right">
            <Button onClick={() => dismissGenerateInvoiceModal()}>
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => senGenerateInvoiceRequest()}
            >
              Yes
            </Button>
          </Stack>
        </>
      ) : loadingFlag ? (
        <>
          <div align="center">
            <CircularProgress />
            <div>
              {`Generating invoice`}
              <br />
              This may take some time relative to the orderitems
            </div>
          </div>
          {errorInfo.error ? (
            <>
              <br />
              <br />
              {`There was an error while generating the invoice`}
              <br />
              <br />
              <span
                style={{
                  color: "red",
                  wordBreak: "break-word",
                  maxHeight: 160,
                  overflow: "auto",
                  display: "inline-block",
                }}
              >
                <b>Error:</b>
                <br />
                {errorInfo.message}
              </span>
              <div align="right">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => dismissGenerateInvoiceModal()}
                  className={classes.button}
                >
                  Continue
                </Button>
              </div>
            </>
          ) : (
            <></>
          )}
        </>
      ) : (
        <>
          The successfully was generated successfully.
          <div align="right">
            <Button
              variant="contained"
              color="primary"
              onClick={() => dismissGenerateInvoiceModal(true)}
              className={classes.button}
            >
              Continue
            </Button>
          </div>
        </>
      )}
    </div>
  );

  const senGenerateInvoiceRequest = async () => {
    setLoadingFlag(true);

    if (orderId !== null) {
      await backend
        .post(`${API_URL}orders/${orderId}/generateinvoice`)
        .then(({ data }) => {
          props.history.push(`/order/${orderId}/invoice`);
        })
        .catch((error) => {
          console.log(error);
          const errorData = error.response.data;

          setErrorInfo({
            error: true,
            message:
              typeof errorData === "object"
                ? errorData.hasOwnProperty("message")
                  ? errorData.message
                  : errorData.detail
                : error.message,
          });
        });
    }
  };

  useEffect(() => {
    const getOrder = async () => {
      await backend
        .get(`${API_URL}orders/${orderId}`)
        .then(({ data }) => {
          setOrder(data);
        })
        .catch((error) => {
          console.log(error);
          props.history.push("/orders");
        });
    };

    if (!isNaN(orderId)) {
      getOrder();
    }
  }, [orderId, props]);

  useEffect(() => {
    const getCompanyLocations = async () => {
      await backend
        .get(`${API_URL}companylocations?no_page=1`)
        .then(({ data }) => {
          setCompanyLocations(data);
        });
    };

    const getOrderItems = async () => {
      await backend
        .get(`${API_URL}orderitems?order=${order.id}&no_page=1`)
        .then(({ data }) => {
          setOrderItems(data);
        });
    };

    const getCustomer = async () => {
      await backend
        .get(`${API_URL}users/${order.customer.user_id}`)
        .then(({ data }) => {
          setCustomer(data);
        });
    };

    getCompanyLocations();

    if (order.hasOwnProperty("id")) {
      getOrderItems();
    }

    if (order.customer) {
      getCustomer();
    }
  }, [order]);

  useEffect(() => {
    const getProducts = async () => {
      const customerCompanyLocations = customer.company
        ? companyLocations
            .filter((item) => item.company_id === customer.company)
            .map((item) => item.id)
        : [];

      let orderItemsOriUPC = [];
      const orderItemsUPC = orderItems.map((item) => {
        if (item.original_product !== item.product) {
          orderItemsOriUPC.push(item.original_product);
        }

        return item.product;
      });

      const orderItemsNOri = [...orderItemsOriUPC, ...orderItemsUPC];

      const companyLocationIdStr =
        customerCompanyLocations.join("&company_location=");
      const productIdStr = orderItemsNOri.join("&upc=");
      await backend
        .get(
          `${API_URL}products?company_location=${companyLocationIdStr}&upc=${productIdStr}&include_inactive=true&include_nonprimary=true&no_page=1`,
        )
        .then(({ data }) => {
          setProducts(data);
        });
    };

    if (orderItems.length && !products.length && companyLocations.length) {
      getProducts();
    }
  }, [companyLocations, customer, orderItems, products]);

  useEffect(() => {
    const orderItemsMapping = () => {
      setOrderItems((prevState) =>
        prevState.map((item) => {
          const productData = products.find(
            (product) => product.upc === item.product,
          );

          if (productData.hasOwnProperty("upc")) {
            return {
              ...productData,
              ...item,
            };
          }

          return item;
        }),
      );
    };

    if (orderItems.length && products.length && !orderItemsMapped) {
      orderItemsMapping();
    }
  }, [orderItems, orderItemsMapped, products]);

  useEffect(() => {
    setOrderItemsMapped(orderItems.every((item) => item.upc));
  }, [orderItems]);

  useEffect(() => {
    const getOrderList = async () => {
      await backend
        .get(
          `${API_URL}orderlists?no_page=1&visible=True&company_id=${customer.company}`,
        )
        .then(({ data }) => {
          setOrderList(data);
        });
    };

    const getOrderListPricing = () => {
      let orderListPricingArray = [];

      Promise.all(
        orderList.map(async (item) => {
          await backend
            .get(`${API_URL}orderlistprices?no_page=1&order_list=${item.id}`)
            .then(({ data }) => {
              orderListPricingArray = [...orderListPricingArray, ...data];
            });
        }),
      ).then(() => {
        setOrderListPricing(orderListPricingArray);
      });
    };

    if (orderItemsMapped) {
      if (customer.company && orderList === null) {
        getOrderList();
      }

      if (orderList !== null && orderListPricing === null) {
        getOrderListPricing();
      }
    }
  }, [customer, orderItemsMapped, orderList, orderListPricing]);

  return (
    <>
      <CssBaseline />
      <Container>
        <Modal open={deleteModal}>{deleteModalContent}</Modal>
        <Modal open={addToCartModal}>{addToCartModalContent}</Modal>
        <Modal open={generateInvoiceModal}>{generateInvoiceModalContent}</Modal>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={true} sm={true}>
                <Typography variant="h6" component="div">
                  Order details
                </Typography>
              </Grid>
              <Grid item xs="auto" sm="auto">
                {orderItemsMapped ? (
                  <>
                    <Link
                      to={{
                        pathname: `/order/${orderId}/print`,
                        search: "?from=order",
                        state: {
                          customer,
                          order,
                          orderItems,
                        },
                      }}
                      style={{ textDecoration: "none", marginRight: 8 }}
                    >
                      <Tooltip title="Print view">
                        <IconButton variant="contained">
                          <PrintIcon color="inherit" />
                        </IconButton>
                      </Tooltip>
                    </Link>
                    {currentUserStore && currentUserStore.is_staff ? (
                      <Tooltip
                        title={
                          order.status === "i"
                            ? "Cannot delete invoiced order"
                            : "Delete order"
                        }
                      >
                        <IconButton
                          variant="contained"
                          {...(order.status === "i"
                            ? undefined
                            : { onClick: () => toggleDeleteModal() })}
                        >
                          <DeleteIcon
                            color={
                              isDeleting || order.status === "i"
                                ? "disabled"
                                : "error"
                            }
                          />
                        </IconButton>
                      </Tooltip>
                    ) : (
                      <></>
                    )}
                  </>
                ) : (
                  <></>
                )}
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <DetailsOrder
              columns={!isNaN(orderId) ? columns["order"] : columns["cart"]}
              customer={customer}
              data={
                !isNaN(orderId)
                  ? orderItems
                  : cartStore[customerStore.id].products
              }
              editable={true}
              order={order}
              setOrder={setOrder}
            />
          </Grid>
          <Grid
            item
            xs={12}
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            {currentUserStore && currentUserStore.is_staff ? (
              <>
                <Link
                  to={{
                    pathname: "/orders/picklist/details",
                    search: "?from=order",
                    state: {
                      sortingState: "bin",
                      filterState: "",
                      bulkState: false,
                      dateRangeState: [
                        new Date(order.delivery_date),
                        new Date(order.delivery_date),
                      ],
                      ordersState: [order],
                      multiple: false,
                    },
                  }}
                  style={{
                    marginLeft: "10px",
                    textDecoration: "none",
                  }}
                >
                  <Button variant="contained">PickList</Button>
                </Link>
                <Link
                  to={{
                    pathname: "/scan",
                    search: "?from=order",
                    state: {
                      sortingState: "bin",
                      filterState: "",
                      bulkState: false,
                      dateRangeState: [
                        new Date(order.delivery_date),
                        new Date(order.delivery_date),
                      ],
                      ordersState: [order],
                    },
                  }}
                  style={{
                    marginLeft: "10px",
                    textDecoration: "none",
                  }}
                >
                  <Button variant="contained">Scan</Button>
                </Link>
              </>
            ) : (
              <></>
            )}
            {currentUserStore &&
            currentUserStore.is_staff &&
            !order.invoiced ? (
              <Button
                variant="contained"
                className="view-invoice-button"
                onClick={() => toggleGenerateInvoiceModal()}
                style={{ marginLeft: "10px", textDecoration: "none" }}
              >
                Generate Invoice
              </Button>
            ) : (
              <Button
                variant="contained"
                disabled={!order.invoiced}
                className="view-invoice-button"
                onClick={() => handleClickViewInvoice()}
                style={{ marginLeft: "10px" }}
              >
                View Invoice
              </Button>
            )}
            <Button
              variant="contained"
              onClick={() => toggleAddToCartModal()}
              disabled={
                isAddingToCart ||
                orderList === null ||
                orderListPricing === null
              }
              style={{ marginLeft: "10px", textDecoration: "none" }}
              className="replicate-order-button"
            >
              Replicate Order
            </Button>
            <Link
              to="/orders"
              style={{ marginLeft: "10px", textDecoration: "none" }}
            >
              <Button variant="contained">Back</Button>
            </Link>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default Details;
